import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { VASProcessedTypes } from './types'
import {
  viewVASOverviewFailure,
  viewVASOverviewSuccess,
  exportViewVASOverviewFailure,
  exportViewVASOverviewSuccess
} from './actions'
import { callApiPost } from '../../utils/api'
import { DataStream } from '../../interfaces'
import { path } from '../../helpers/path'
import { logout } from '../auth'

function* viewVASOverview({ payload }: { type: string; payload: any }): any {
  try {
    const res = yield call(callApiPost, 'reports/viewvasoverview', payload)
    yield put(viewVASOverviewSuccess(res.data))
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout())
        localStorage.removeItem('user')
        localStorage.removeItem('persist:root')
        localStorage.clear()
        window.location.href = path.login
      } else {
        yield put(viewVASOverviewFailure(err.response.data))
      }
    } else {
      yield put(viewVASOverviewFailure('An unknown error occurred'))
    }
  }
}

function* exportViewVASOverview({ payload }: { type: string; payload: any }): any {
  try {
    const res = yield call(callApiPost, `reports/viewvasoverviewexport`, payload)
    yield put(exportViewVASOverviewSuccess(res.data))
    let file: DataStream = res.data
    const link = document.createElement('a')
    link.href = `data:${file.contentType};base64,${file.fileContents}`
    link.download = file.fileDownloadName
    link.click()
  } catch (err: any) {
    if (err && err.response) {
      if (err.response.status === 401) {
        yield put(logout())
        localStorage.removeItem('user')
        localStorage.removeItem('persist:root')
        localStorage.clear()
        window.location.href = path.login
      } else {
        yield put(exportViewVASOverviewFailure(err.response.data))
      }
    } else {
      yield put(exportViewVASOverviewFailure('An unknown error occurred'))
    }
  }
}

function* watchViewVASOverview() {
  yield takeEvery(VASProcessedTypes.VIEW_VAS_OVERVIEW_REQUEST, viewVASOverview)
}

function* watchExportViewVASOverview() {
  yield takeEvery(VASProcessedTypes.EXPORT_VIEW_VAS_OVERVIEW_REQUEST, exportViewVASOverview)
}

function* vasSaga(): Generator {
  yield all([fork(watchViewVASOverview), fork(watchExportViewVASOverview)])
}

export { vasSaga }
